module.exports = __webpack_public_path__ + "img/928c36e.png";